import React, { useRef } from 'react';
import {
    Grid,
    Box,
    Typography,
    Button,
    makeStyles,
    // No necesitamos createMuiTheme, ThemeProvider, CssBaseline aquí,
    // ya que se asume que App.js (o el componente padre) ya los tiene.
} from '@material-ui/core';
import html2canvas from 'html2canvas';

// Asegúrate de que los estilos (classes) estén definidos.
// Estos deberían ser parte del mismo archivo donde definiste useStyles anteriormente.
const useStyles = makeStyles((theme) => ({
    containerOtp: {
        marginTop: theme.spacing(5), // Espacio superior
        width: 'calc(100% - 40%)', // Simula 30% de margen a cada lado (100% - (30% + 30%))
        marginLeft: 'auto',
        marginRight: 'auto',

        [theme.breakpoints.down('sm')]: {
            width: '100%',
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    instructionBox: {
        display: 'flex',
        justifyContent: 'center',
        // Si quieres que los ítems se centren verticalmente en una fila:
        alignItems: 'center', //
        width: "100%", // Asegura que ocupe todo el ancho disponible

        marginBottom: theme.spacing(1),

    },
    titleReferenceBox: {
        display: 'flex',
        justifyContent: 'center',
        // Si quieres que los ítems se centren verticalmente en una fila:
        alignItems: 'center', //
        width: "100%", // Asegura que ocupe todo el ancho disponible

        marginBottom: theme.spacing(3),
        marginTop: -40
    },
    phoneIcon: {
        fontSize: 32, // Larger icon
        marginRight: theme.spacing(2),
        paddingTop: theme.spacing(0.5), // Adjust to align with text baseline
    },
    textoData: {
        fontSize: '1.1rem',
        fontWeight: 'bold',
        lineHeight: 1.5,
        textAlign: 'right',
        marginRight: theme.spacing(1), // Espacio entre etiqueta y valor
    },
    textoDataValue: {
        fontSize: '1.1rem',
        lineHeight: 1.5,
        textAlign: 'left',

        marginLeft: theme.spacing(1), // Espacio entre etiqueta y valor
    },
    textoReferencia: {
        fontSize: '1.4rem',
        color: "#F67B40",
        lineHeight: 1.5,
        textAlign: 'center',
    },
    pinFieldContainer: {
        display: 'flex', // Usa flexbox para organizar las entradas horizontalmente
        justifyContent: 'center', // Centra las entradas
        gap: theme.spacing(1), // Espacio entre entradas (ej. 8px)
        marginBottom: theme.spacing(3),
        fontWeight: 'bold',
        [theme.breakpoints.down('sm')]: {
            width: '100%',
            marginLeft: 0,
            marginRight: 0,
        },
    },
    pinInputField: {
        // Estos estilos se aplicarán directamente a cada entrada generada por PinField
        width: '30px !important', // Ancho fijo para cuadrado. Usa !important para anular estilos en línea de la librería.
        height: '30px !important', // Alto fijo para cuadrado.
        fontSize: '1.5rem',
        textAlign: 'center',
        border: `1px solid ${theme.palette.grey[400]}`, // Borde gris
        borderRadius: theme.shape.borderRadius, // Esquinas redondeadas
        outline: 'none',
        transition: 'border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
        '&:focus': {
            borderColor: theme.palette.primary.main, // Borde azul al enfocar
            boxShadow: `0 0 0 3px ${theme.palette.primary.light}`, // Sombra azul al enfocar
        },
        // Opcional: para el comportamiento del teclado numérico móvil
        '-moz-appearance': 'textfield',
        '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
            '-webkit-appearance': 'none',
            margin: 0,
        },
    },
    resendButton: {
        backgroundColor: "transparent", // Fondo negro
        color: "blue", // Texto blanco
        borderRadius: theme.shape.borderRadius, // Bordes redondeados
        padding: theme.spacing(1.5, 3), // Padding
        boxShadow: "none",
        marginBottom: theme.spacing(2),
        '&:hover': {
            backgroundColor: "transparent", // Color más oscuro al pasar el ratón
            boxShadow: 'none',
        },
    },
    dividerDashed: {
        borderBottom: `1px dashed #d9d9d9`, // Borde inferior discontinuo
        width: '100%', // Que ocupe todo el ancho disponible
        margin: theme.spacing(3, 0), // Margen superior e inferior para separarlo del contenido
        // Puedes ajustar el margin si necesitas más/menos espacio
    },

    boldText: {
        fontWeight: 'bold', // Negrita

    },
}));


// Function to get and format the current date
const getCurrentFormattedDate = () => {
    const today = new Date();
    const day = String(today.getDate()).padStart(2, '0'); // Get day and pad with leading zero if needed
    const month = String(today.getMonth() + 1).padStart(2, '0'); // Get month (0-indexed, so add 1) and pad
    const year = today.getFullYear();
    return `${day}/${month}/${year}`;
};

// Function to get and format the current time
const getCurrentFormattedTime = () => {
    const now = new Date();
    const hours = String(now.getHours()).padStart(2, '0'); // Get hours and pad
    const minutes = String(now.getMinutes()).padStart(2, '0'); // Get minutes and pad
    const seconds = String(now.getSeconds()).padStart(2, '0'); // Get seconds and pad
    return `${hours}:${minutes}:${seconds}`;
};


const formattedDate = getCurrentFormattedDate();
const formattedTime = getCurrentFormattedTime();



const StatusTransactionComponent = (props) => {
    const classes = useStyles();

    const { datosUsuario } = props;


    return (
        <>

            <Grid container className={classes.containerOtp} > {/* Contenedor de cuadrícula para los dos campos inferiores */}

                <Grid item xs={12} sm={12} style={{ padding: 1 }} > {/* En pantallas pequeñas ocupa 12 columnas, en medianas y grandes 6 */}
                    <Box className={classes.titleReferenceBox}>

                        <Typography variant="p" className={classes.textoReferencia} >Referencia : {datosUsuario[3]} </Typography>

                    </Box>
                    <Box className={classes.instructionBox}>
                        <Grid item xs={6}>
                            <Typography variant="body1" className={classes.textoData}>
                                Fecha :
                            </Typography>
                        </Grid>
                        <Grid item xs={6}>

                            <Typography variant="body1" className={classes.textoDataValue}>
                                {formattedDate}
                            </Typography>

                        </Grid>


                    </Box>

                    <Box className={classes.instructionBox}>

                        <Grid item xs={6}>
                            <Typography variant="body1" className={classes.textoData}>
                                Hora :
                            </Typography>
                        </Grid>
                        <Grid item xs={6}>

                            <Typography variant="body1" className={classes.textoDataValue}>
                                {getCurrentFormattedTime()}
                            </Typography>

                        </Grid>



                    </Box>

                    {/* 6 -7 */}
                    <Box className={classes.instructionBox}>
                        <Grid item xs={6}>
                            <Typography variant="body1" className={classes.textoData}>
                                Destino :
                            </Typography>
                        </Grid>
                        <Grid item xs={6}>

                            <Typography variant="body1" className={classes.textoDataValue}>
                                {datosUsuario[6]}
                            </Typography>

                        </Grid>

                    </Box>

                    <Box className={classes.instructionBox}>
                        <Grid item xs={6}>
                            <Typography variant="body1" className={classes.textoData}>
                                CI/Rif :
                            </Typography>
                        </Grid>
                        <Grid item xs={6}>

                            <Typography variant="body1" className={classes.textoDataValue}>
                                {datosUsuario[7]}
                            </Typography>

                        </Grid>

                    </Box>

                    <Box className={classes.instructionBox}>
                        <Grid item xs={6}>
                            <Typography variant="body1" className={classes.textoData}>
                                Monto:
                            </Typography>
                        </Grid>
                        <Grid item xs={6}>

                            <Typography variant="body1" className={classes.textoDataValue}>
                                {new Intl.NumberFormat('es-VE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(datosUsuario[8])}
                            </Typography>

                        </Grid>

                    </Box>

                    <Box className={classes.instructionBox}>
                        <Grid item xs={6}>
                            <Typography variant="body1" className={classes.textoData}>
                                Descripción :
                            </Typography>
                        </Grid>
                        <Grid item xs={6}>

                            <Typography variant="body1" className={classes.textoDataValue}>
                                {datosUsuario[4]}
                            </Typography>

                        </Grid>

                    </Box>

                </Grid>

                {/* DIVIDER */}
                {/* <Grid item xs={12}> {
    <Box className={classes.dividerDashed} />
</Grid> */}

                {/* <Grid container justify="center" >
    <Grid item xs={12} style={{ padding: 10 }}>
        
        <div className={`${classes.pinFieldContainer}`}>
            DATOS DEL PAGADOR
        </div>

        <Box className={classes.instructionBox}>


            <Typography variant="p" className={classes.textoData} >Cédula : {datosUsuario[1]} </Typography>

        </Box>
        <Box className={classes.instructionBox}>

            <Typography variant="p" className={classes.textoData} >Banco : {datosUsuario[0]} </Typography>

        </Box>
        <Box className={classes.instructionBox}>

            <Typography variant="p" className={classes.textoData} >Teléfono : {datosUsuario[2]} </Typography>

        </Box>
    </Grid>


</Grid> */}

            </Grid>



        </>
    )
}

export default StatusTransactionComponent;